(() => {
  if (window.__gsTroubleshootingMobileFilterLoaded) return;
  window.__gsTroubleshootingMobileFilterLoaded = true;

  const enhanceFilter = (filter) => {
    if (!filter || filter.dataset.mobileSelectEnhanced === 'true') return;

    const buttonsWrap = filter.querySelector('.gs-troubleshooting__model-buttons');
    if (!buttonsWrap) return;

    const buttons = Array.from(buttonsWrap.querySelectorAll('.gs-troubleshooting__model-button'));
    if (!buttons.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'gs-troubleshooting__model-select-wrap';

    const label = document.createElement('label');
    label.className = 'gs-troubleshooting__model-select-label';
    label.textContent = window.gsT('troubleshooting.select_model_family');

    const select = document.createElement('select');
    select.className = 'gs-troubleshooting__model-select';
    select.setAttribute('aria-label', window.gsT('troubleshooting.select_model_family_aria'));

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = window.gsT('troubleshooting.choose_model_family');
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    const optionMap = new Map();

    buttons.forEach((button) => {
      const option = document.createElement('option');
      option.value = button.dataset.troubleshootingModel || '';
      option.textContent = (button.textContent || '').trim();
      select.appendChild(option);
      optionMap.set(button, option);
    });

    const sync = () => {
      buttons.forEach((button) => {
        const option = optionMap.get(button);
        if (!option) return;
        option.textContent = (button.textContent || '').trim();
        option.hidden = button.hidden;
        option.disabled = button.hidden;
      });

      const active = buttons.find((button) => button.getAttribute('aria-pressed') === 'true' && !button.hidden);
      select.value = active ? (active.dataset.troubleshootingModel || '') : '';
    };

    select.addEventListener('change', () => {
      const target = buttons.find((button) => (button.dataset.troubleshootingModel || '') === select.value);
      if (target) target.click();
    });

    const stateObserver = new MutationObserver(sync);
    stateObserver.observe(buttonsWrap, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-pressed', 'hidden']
    });

    wrap.appendChild(label);
    wrap.appendChild(select);
    buttonsWrap.before(wrap);
    filter.dataset.mobileSelectEnhanced = 'true';
    sync();
  };

  const scan = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.gs-troubleshooting__model-filter').forEach(enhanceFilter);
  };

  const boot = () => {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('.gs-troubleshooting__model-filter')) enhanceFilter(node);
          scan(node);
        });
      });
    });

    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
